import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import { NotAuthorizedComponent } from './components/not-authorized/not-authorized.component';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { PasswordSetterComponent } from './components/password-setter/password-setter.component';
import { ReactiveFormsModule } from '@angular/forms';
import { ShowControlErrorsModule } from '../shared/components/error-container/show-control-errors/show-control-errors.module';

@NgModule({
    declarations: [
        NotAuthorizedComponent,
        NotFoundComponent,
        PasswordSetterComponent
    ],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        ShowControlErrorsModule,
        SharedModule
    ],
    exports: [
        SharedModule,
        CommonModule
    ],
    providers:  [ ]
})
export class CoreModule { }
